import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormResponseService {

  constructor(private http: HttpClient) { }

  getSignedReport(responseId: string, filePath: string, certLink?: string): Observable<Blob> {
    let params = new HttpParams().set('responseId', responseId).set('filePath', filePath);

    if (certLink) {
      params = params.set('cert_link', certLink);
    }

    const headers = new HttpHeaders({
      'Authorization': sessionStorage.getItem('token') as string
    });

    return this.http.get(`${environment.api}/api/form-group-responses/get-form-response-report`, {
      params,
      headers,
      responseType: 'blob'
    });
  }

  getSignedReportPublic(responseId: string, filePath: string, certLink: string): Observable<Blob> {
    const params = new HttpParams().set('responseId', responseId)
    .set('filePath', filePath)
    .set('cert_link', certLink);

    return this.http.get(`${environment.api}/api/form-group-responses/get-form-response-report-without-authorization`, {
      params,
      responseType: 'blob'
    });
  }
}
